import { render, staticRenderFns } from "./forgot-password-view.vue?vue&type=template&id=04ebb482&scoped=true&"
import script from "./forgot-password-view.vue?vue&type=script&lang=js&"
export * from "./forgot-password-view.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password-view.vue?vue&type=style&index=0&id=04ebb482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebb482",
  null
  
)

export default component.exports